unit View.Areceber.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewAreceberEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbcliente_id: TLabel;
    edcliente_id: TDBEdit;
    lbdocumento: TLabel;
    eddocumento: TDBEdit;
    lbparcela: TLabel;
    edparcela: TDBEdit;
    lbemissao: TLabel;
    edemissao: TDBEdit;
    lbvencimento: TLabel;
    edvencimento: TDBEdit;
    lbpagamento: TLabel;
    edpagamento: TDBEdit;
    lbvenda_id: TLabel;
    edvenda_id: TDBEdit;
    lbcupons_id: TLabel;
    edcupons_id: TDBEdit;
    lbvalor_total: TLabel;
    edvalor_total: TDBEdit;
    lbvalor_saldo_pendente: TLabel;
    edvalor_saldo_pendente: TDBEdit;
    lbvalor_pago: TLabel;
    edvalor_pago: TDBEdit;
    lbmodalidade_id: TLabel;
    edmodalidade_id: TDBEdit;
    lbareceber_comissao: TLabel;
    edareceber_comissao: TDBEdit;
    lbstatus_id: TLabel;
    edstatus_id: TDBEdit;
    lbobservacao: TLabel;
    edobservacao: TDBEdit;
    lbfuncionario_id: TLabel;
    edfuncionario_id: TDBEdit;
    lbconhecimento_transporte_id: TLabel;
    edconhecimento_transporte_id: TDBEdit;
    lbareceber_credito: TLabel;
    edareceber_credito: TDBEdit;
    lbdevolucao_id: TLabel;
    eddevolucao_id: TDBEdit;
    lbrenegociacao_id: TLabel;
    edrenegociacao_id: TDBEdit;
    lbvenda_servico_id: TLabel;
    edvenda_servico_id: TDBEdit;
    lboperadora_cartao_id: TLabel;
    edoperadora_cartao_id: TDBEdit;
    lbnsu_documento: TLabel;
    ednsu_documento: TDBEdit;
    lbcheque_pendente: TLabel;
    edcheque_pendente: TDBEdit;
    lbvalor_juros_pendente: TLabel;
    edvalor_juros_pendente: TDBEdit;
    lbstatus_crediario_id: TLabel;
    edstatus_crediario_id: TDBEdit;
    lbmensalidade_id: TLabel;
    edmensalidade_id: TDBEdit;
    lbcredito_utilizado: TLabel;
    edcredito_utilizado: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientAreceberGet: TXDataWebClient;
    XDataClientAreceberDelete: TXDataWebClient;
    AreceberDataset: TXDataWebDataSet;
    AreceberDatasetid: TIntegerField;
    AreceberDatasetaliado_id: TIntegerField;
    AreceberDatasetdata_base_id: TIntegerField;
    AreceberDatasetcliente_id: TIntegerField;
    AreceberDatasetdocumento: TStringField;
    AreceberDatasetparcela: TStringField;
    AreceberDatasetemissao: TDateTimeField;
    AreceberDatasetvencimento: TDateTimeField;
    AreceberDatasetpagamento: TDateTimeField;
    AreceberDatasetvenda_id: TIntegerField;
    AreceberDatasetcupons_id: TIntegerField;
    AreceberDatasetvalor_total: TFloatField;
    AreceberDatasetvalor_saldo_pendente: TFloatField;
    AreceberDatasetvalor_pago: TFloatField;
    AreceberDatasetmodalidade_id: TIntegerField;
    AreceberDatasetareceber_comissao: TBooleanField;
    AreceberDatasetstatus_id: TIntegerField;
    AreceberDatasetobservacao: TStringField;
    AreceberDatasetfuncionario_id: TIntegerField;
    AreceberDatasetconhecimento_transporte_id: TIntegerField;
    AreceberDatasetareceber_credito: TBooleanField;
    AreceberDatasetdevolucao_id: TIntegerField;
    AreceberDatasetrenegociacao_id: TIntegerField;
    AreceberDatasetvenda_servico_id: TIntegerField;
    AreceberDatasetoperadora_cartao_id: TIntegerField;
    AreceberDatasetnsu_documento: TStringField;
    AreceberDatasetcheque_pendente: TBooleanField;
    AreceberDatasetvalor_juros_pendente: TFloatField;
    AreceberDatasetstatus_crediario_id: TIntegerField;
    AreceberDatasetmensalidade_id: TIntegerField;
    AreceberDatasetcredito_utilizado: TBooleanField;
    AreceberDatasetcodigo_interno: TIntegerField;
    AreceberDatasetexcluido: TBooleanField;
    AreceberDatasetinclusao: TDateTimeField;
    AreceberDatasetalteracao: TDateTimeField;
    AreceberDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientAreceberGetLoad(Response: TXDataClientResponse);
    procedure XDataClientAreceberDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientAreceberDeleteError(Error: TXDataClientError);
    procedure AreceberDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewAreceberEdit: TFViewAreceberEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewAreceberEdit }

procedure TFViewAreceberEdit.btSaveClick(Sender: TObject);
begin
  if AreceberDataset.State in dsEditModes then
  begin
        AreceberDataset.Post;
    AreceberDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewAreceberEdit.btDeleteClick(Sender: TObject);
begin
  if AreceberDataset.State in dsEditModes then
    AreceberDataset.Post;
  XDataClientAreceberDelete.Delete(AreceberDataset.EntitySetName,
    TJSObject(AreceberDataset.CurrentData));
end;


class function TFViewAreceberEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewAreceberEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewAreceberEdit.InsertEntity;
begin
  AreceberDataset.Close;
  AreceberDataset.SetJsonData('{}');
  AreceberDataset.Open;
  AreceberDataset.Insert;
end;

class function TFViewAreceberEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewAreceberEdit(AForm).FInserting := AInserting;
    TFViewAreceberEdit(AForm).FId := AId;
    TFViewAreceberEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewAreceberEdit(AForm).InsertEntity
    else
      TFViewAreceberEdit(AForm).LoadEntity;
    TFViewAreceberEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewAreceberEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewAreceberEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    AreceberDataset.Connection.Model.DefaultSchema.FindEntityType(
      AreceberDataset.EntitySetName
    )
  );
  XDataClientAreceberGet.Get(AreceberDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewAreceberEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewAreceberEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewAreceberEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewAreceberEdit.XDataClientAreceberGetLoad(Response: TXDataClientResponse);
begin
  AreceberDataset.Close;
  AreceberDataset.SetJsonData(Response.Result);
  AreceberDataset.Open;
  
  AreceberDataset.Edit;  
end;

procedure TFViewAreceberEdit.XDataClientAreceberDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewAreceberEdit.XDataClientAreceberDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewAreceberEdit.AreceberDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewAreceberEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewAreceberEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.areceber.form.message');
  lbMessage := TLabel.Create('view.areceber.form.message.label');
  btCloseMessage := TButton.Create('view.areceber.form.message.button');
  btCancel := TButton.Create('view.areceber.form.btBack');
  btSave := TButton.Create('view.areceber.form.btSave');
  btDelete := TButton.Create('view.areceber.form.btDelete');
  lbid := TLabel.Create('view.areceber.form.lbid');
  edid := TDBEdit.Create('view.areceber.form.edid');
  lbaliado_id := TLabel.Create('view.areceber.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.areceber.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.areceber.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.areceber.form.eddata_base_id');
  lbcliente_id := TLabel.Create('view.areceber.form.lbcliente_id');
  edcliente_id := TDBEdit.Create('view.areceber.form.edcliente_id');
  lbdocumento := TLabel.Create('view.areceber.form.lbdocumento');
  eddocumento := TDBEdit.Create('view.areceber.form.eddocumento');
  lbparcela := TLabel.Create('view.areceber.form.lbparcela');
  edparcela := TDBEdit.Create('view.areceber.form.edparcela');
  lbemissao := TLabel.Create('view.areceber.form.lbemissao');
  edemissao := TDBEdit.Create('view.areceber.form.edemissao');
  lbvencimento := TLabel.Create('view.areceber.form.lbvencimento');
  edvencimento := TDBEdit.Create('view.areceber.form.edvencimento');
  lbpagamento := TLabel.Create('view.areceber.form.lbpagamento');
  edpagamento := TDBEdit.Create('view.areceber.form.edpagamento');
  lbvenda_id := TLabel.Create('view.areceber.form.lbvenda_id');
  edvenda_id := TDBEdit.Create('view.areceber.form.edvenda_id');
  lbcupons_id := TLabel.Create('view.areceber.form.lbcupons_id');
  edcupons_id := TDBEdit.Create('view.areceber.form.edcupons_id');
  lbvalor_total := TLabel.Create('view.areceber.form.lbvalor_total');
  edvalor_total := TDBEdit.Create('view.areceber.form.edvalor_total');
  lbvalor_saldo_pendente := TLabel.Create('view.areceber.form.lbvalor_saldo_pendente');
  edvalor_saldo_pendente := TDBEdit.Create('view.areceber.form.edvalor_saldo_pendente');
  lbvalor_pago := TLabel.Create('view.areceber.form.lbvalor_pago');
  edvalor_pago := TDBEdit.Create('view.areceber.form.edvalor_pago');
  lbmodalidade_id := TLabel.Create('view.areceber.form.lbmodalidade_id');
  edmodalidade_id := TDBEdit.Create('view.areceber.form.edmodalidade_id');
  lbareceber_comissao := TLabel.Create('view.areceber.form.lbareceber_comissao');
  edareceber_comissao := TDBEdit.Create('view.areceber.form.edareceber_comissao');
  lbstatus_id := TLabel.Create('view.areceber.form.lbstatus_id');
  edstatus_id := TDBEdit.Create('view.areceber.form.edstatus_id');
  lbobservacao := TLabel.Create('view.areceber.form.lbobservacao');
  edobservacao := TDBEdit.Create('view.areceber.form.edobservacao');
  lbfuncionario_id := TLabel.Create('view.areceber.form.lbfuncionario_id');
  edfuncionario_id := TDBEdit.Create('view.areceber.form.edfuncionario_id');
  lbconhecimento_transporte_id := TLabel.Create('view.areceber.form.lbconhecimento_transporte_id');
  edconhecimento_transporte_id := TDBEdit.Create('view.areceber.form.edconhecimento_transporte_id');
  lbareceber_credito := TLabel.Create('view.areceber.form.lbareceber_credito');
  edareceber_credito := TDBEdit.Create('view.areceber.form.edareceber_credito');
  lbdevolucao_id := TLabel.Create('view.areceber.form.lbdevolucao_id');
  eddevolucao_id := TDBEdit.Create('view.areceber.form.eddevolucao_id');
  lbrenegociacao_id := TLabel.Create('view.areceber.form.lbrenegociacao_id');
  edrenegociacao_id := TDBEdit.Create('view.areceber.form.edrenegociacao_id');
  lbvenda_servico_id := TLabel.Create('view.areceber.form.lbvenda_servico_id');
  edvenda_servico_id := TDBEdit.Create('view.areceber.form.edvenda_servico_id');
  lboperadora_cartao_id := TLabel.Create('view.areceber.form.lboperadora_cartao_id');
  edoperadora_cartao_id := TDBEdit.Create('view.areceber.form.edoperadora_cartao_id');
  lbnsu_documento := TLabel.Create('view.areceber.form.lbnsu_documento');
  ednsu_documento := TDBEdit.Create('view.areceber.form.ednsu_documento');
  lbcheque_pendente := TLabel.Create('view.areceber.form.lbcheque_pendente');
  edcheque_pendente := TDBEdit.Create('view.areceber.form.edcheque_pendente');
  lbvalor_juros_pendente := TLabel.Create('view.areceber.form.lbvalor_juros_pendente');
  edvalor_juros_pendente := TDBEdit.Create('view.areceber.form.edvalor_juros_pendente');
  lbstatus_crediario_id := TLabel.Create('view.areceber.form.lbstatus_crediario_id');
  edstatus_crediario_id := TDBEdit.Create('view.areceber.form.edstatus_crediario_id');
  lbmensalidade_id := TLabel.Create('view.areceber.form.lbmensalidade_id');
  edmensalidade_id := TDBEdit.Create('view.areceber.form.edmensalidade_id');
  lbcredito_utilizado := TLabel.Create('view.areceber.form.lbcredito_utilizado');
  edcredito_utilizado := TDBEdit.Create('view.areceber.form.edcredito_utilizado');
  lbcodigo_interno := TLabel.Create('view.areceber.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.areceber.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.areceber.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.areceber.form.edexcluido');
  lbinclusao := TLabel.Create('view.areceber.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.areceber.form.edinclusao');
  lbalteracao := TLabel.Create('view.areceber.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.areceber.form.edalteracao');
  lbexclusao := TLabel.Create('view.areceber.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.areceber.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  AreceberDataset := TXDataWebDataSet.Create(Self);
  AreceberDatasetid := TIntegerField.Create(Self);
  AreceberDatasetaliado_id := TIntegerField.Create(Self);
  AreceberDatasetdata_base_id := TIntegerField.Create(Self);
  AreceberDatasetcliente_id := TIntegerField.Create(Self);
  AreceberDatasetdocumento := TStringField.Create(Self);
  AreceberDatasetparcela := TStringField.Create(Self);
  AreceberDatasetemissao := TDateTimeField.Create(Self);
  AreceberDatasetvencimento := TDateTimeField.Create(Self);
  AreceberDatasetpagamento := TDateTimeField.Create(Self);
  AreceberDatasetvenda_id := TIntegerField.Create(Self);
  AreceberDatasetcupons_id := TIntegerField.Create(Self);
  AreceberDatasetvalor_total := TFloatField.Create(Self);
  AreceberDatasetvalor_saldo_pendente := TFloatField.Create(Self);
  AreceberDatasetvalor_pago := TFloatField.Create(Self);
  AreceberDatasetmodalidade_id := TIntegerField.Create(Self);
  AreceberDatasetareceber_comissao := TBooleanField.Create(Self);
  AreceberDatasetstatus_id := TIntegerField.Create(Self);
  AreceberDatasetobservacao := TStringField.Create(Self);
  AreceberDatasetfuncionario_id := TIntegerField.Create(Self);
  AreceberDatasetconhecimento_transporte_id := TIntegerField.Create(Self);
  AreceberDatasetareceber_credito := TBooleanField.Create(Self);
  AreceberDatasetdevolucao_id := TIntegerField.Create(Self);
  AreceberDatasetrenegociacao_id := TIntegerField.Create(Self);
  AreceberDatasetvenda_servico_id := TIntegerField.Create(Self);
  AreceberDatasetoperadora_cartao_id := TIntegerField.Create(Self);
  AreceberDatasetnsu_documento := TStringField.Create(Self);
  AreceberDatasetcheque_pendente := TBooleanField.Create(Self);
  AreceberDatasetvalor_juros_pendente := TFloatField.Create(Self);
  AreceberDatasetstatus_crediario_id := TIntegerField.Create(Self);
  AreceberDatasetmensalidade_id := TIntegerField.Create(Self);
  AreceberDatasetcredito_utilizado := TBooleanField.Create(Self);
  AreceberDatasetcodigo_interno := TIntegerField.Create(Self);
  AreceberDatasetexcluido := TBooleanField.Create(Self);
  AreceberDatasetinclusao := TDateTimeField.Create(Self);
  AreceberDatasetalteracao := TDateTimeField.Create(Self);
  AreceberDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientAreceberGet := TXDataWebClient.Create(Self);
  XDataClientAreceberDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbcliente_id.BeforeLoadDFMValues;
  edcliente_id.BeforeLoadDFMValues;
  lbdocumento.BeforeLoadDFMValues;
  eddocumento.BeforeLoadDFMValues;
  lbparcela.BeforeLoadDFMValues;
  edparcela.BeforeLoadDFMValues;
  lbemissao.BeforeLoadDFMValues;
  edemissao.BeforeLoadDFMValues;
  lbvencimento.BeforeLoadDFMValues;
  edvencimento.BeforeLoadDFMValues;
  lbpagamento.BeforeLoadDFMValues;
  edpagamento.BeforeLoadDFMValues;
  lbvenda_id.BeforeLoadDFMValues;
  edvenda_id.BeforeLoadDFMValues;
  lbcupons_id.BeforeLoadDFMValues;
  edcupons_id.BeforeLoadDFMValues;
  lbvalor_total.BeforeLoadDFMValues;
  edvalor_total.BeforeLoadDFMValues;
  lbvalor_saldo_pendente.BeforeLoadDFMValues;
  edvalor_saldo_pendente.BeforeLoadDFMValues;
  lbvalor_pago.BeforeLoadDFMValues;
  edvalor_pago.BeforeLoadDFMValues;
  lbmodalidade_id.BeforeLoadDFMValues;
  edmodalidade_id.BeforeLoadDFMValues;
  lbareceber_comissao.BeforeLoadDFMValues;
  edareceber_comissao.BeforeLoadDFMValues;
  lbstatus_id.BeforeLoadDFMValues;
  edstatus_id.BeforeLoadDFMValues;
  lbobservacao.BeforeLoadDFMValues;
  edobservacao.BeforeLoadDFMValues;
  lbfuncionario_id.BeforeLoadDFMValues;
  edfuncionario_id.BeforeLoadDFMValues;
  lbconhecimento_transporte_id.BeforeLoadDFMValues;
  edconhecimento_transporte_id.BeforeLoadDFMValues;
  lbareceber_credito.BeforeLoadDFMValues;
  edareceber_credito.BeforeLoadDFMValues;
  lbdevolucao_id.BeforeLoadDFMValues;
  eddevolucao_id.BeforeLoadDFMValues;
  lbrenegociacao_id.BeforeLoadDFMValues;
  edrenegociacao_id.BeforeLoadDFMValues;
  lbvenda_servico_id.BeforeLoadDFMValues;
  edvenda_servico_id.BeforeLoadDFMValues;
  lboperadora_cartao_id.BeforeLoadDFMValues;
  edoperadora_cartao_id.BeforeLoadDFMValues;
  lbnsu_documento.BeforeLoadDFMValues;
  ednsu_documento.BeforeLoadDFMValues;
  lbcheque_pendente.BeforeLoadDFMValues;
  edcheque_pendente.BeforeLoadDFMValues;
  lbvalor_juros_pendente.BeforeLoadDFMValues;
  edvalor_juros_pendente.BeforeLoadDFMValues;
  lbstatus_crediario_id.BeforeLoadDFMValues;
  edstatus_crediario_id.BeforeLoadDFMValues;
  lbmensalidade_id.BeforeLoadDFMValues;
  edmensalidade_id.BeforeLoadDFMValues;
  lbcredito_utilizado.BeforeLoadDFMValues;
  edcredito_utilizado.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  AreceberDataset.BeforeLoadDFMValues;
  AreceberDatasetid.BeforeLoadDFMValues;
  AreceberDatasetaliado_id.BeforeLoadDFMValues;
  AreceberDatasetdata_base_id.BeforeLoadDFMValues;
  AreceberDatasetcliente_id.BeforeLoadDFMValues;
  AreceberDatasetdocumento.BeforeLoadDFMValues;
  AreceberDatasetparcela.BeforeLoadDFMValues;
  AreceberDatasetemissao.BeforeLoadDFMValues;
  AreceberDatasetvencimento.BeforeLoadDFMValues;
  AreceberDatasetpagamento.BeforeLoadDFMValues;
  AreceberDatasetvenda_id.BeforeLoadDFMValues;
  AreceberDatasetcupons_id.BeforeLoadDFMValues;
  AreceberDatasetvalor_total.BeforeLoadDFMValues;
  AreceberDatasetvalor_saldo_pendente.BeforeLoadDFMValues;
  AreceberDatasetvalor_pago.BeforeLoadDFMValues;
  AreceberDatasetmodalidade_id.BeforeLoadDFMValues;
  AreceberDatasetareceber_comissao.BeforeLoadDFMValues;
  AreceberDatasetstatus_id.BeforeLoadDFMValues;
  AreceberDatasetobservacao.BeforeLoadDFMValues;
  AreceberDatasetfuncionario_id.BeforeLoadDFMValues;
  AreceberDatasetconhecimento_transporte_id.BeforeLoadDFMValues;
  AreceberDatasetareceber_credito.BeforeLoadDFMValues;
  AreceberDatasetdevolucao_id.BeforeLoadDFMValues;
  AreceberDatasetrenegociacao_id.BeforeLoadDFMValues;
  AreceberDatasetvenda_servico_id.BeforeLoadDFMValues;
  AreceberDatasetoperadora_cartao_id.BeforeLoadDFMValues;
  AreceberDatasetnsu_documento.BeforeLoadDFMValues;
  AreceberDatasetcheque_pendente.BeforeLoadDFMValues;
  AreceberDatasetvalor_juros_pendente.BeforeLoadDFMValues;
  AreceberDatasetstatus_crediario_id.BeforeLoadDFMValues;
  AreceberDatasetmensalidade_id.BeforeLoadDFMValues;
  AreceberDatasetcredito_utilizado.BeforeLoadDFMValues;
  AreceberDatasetcodigo_interno.BeforeLoadDFMValues;
  AreceberDatasetexcluido.BeforeLoadDFMValues;
  AreceberDatasetinclusao.BeforeLoadDFMValues;
  AreceberDatasetalteracao.BeforeLoadDFMValues;
  AreceberDatasetexclusao.BeforeLoadDFMValues;
  XDataClientAreceberGet.BeforeLoadDFMValues;
  XDataClientAreceberDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewAreceberEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 1237;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 1177;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 1177;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 1177;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbcliente_id.SetParentComponent(Self);
    lbcliente_id.Name := 'lbcliente_id';
    lbcliente_id.Left := 24;
    lbcliente_id.Top := 273;
    lbcliente_id.Width := 14;
    lbcliente_id.Height := 13;
    lbcliente_id.Caption := 'cliente_id:';
    lbcliente_id.Transparent := True;
    edcliente_id.SetParentComponent(Self);
    edcliente_id.Name := 'edcliente_id';
    edcliente_id.Left := 221;
    edcliente_id.Top := 270;
    edcliente_id.Width := 200;
    edcliente_id.Height := 21;
    edcliente_id.Enabled := True;
    edcliente_id.TabOrder := 9;
    edcliente_id.Text := 'edcliente_id';
    edcliente_id.DataField := 'cliente_id';
    edcliente_id.DataSource := DataSource;
    lbdocumento.SetParentComponent(Self);
    lbdocumento.Name := 'lbdocumento';
    lbdocumento.Left := 24;
    lbdocumento.Top := 300;
    lbdocumento.Width := 14;
    lbdocumento.Height := 13;
    lbdocumento.Caption := 'documento:';
    lbdocumento.Transparent := True;
    eddocumento.SetParentComponent(Self);
    eddocumento.Name := 'eddocumento';
    eddocumento.Left := 221;
    eddocumento.Top := 297;
    eddocumento.Width := 200;
    eddocumento.Height := 21;
    eddocumento.Enabled := True;
    eddocumento.TabOrder := 10;
    eddocumento.Text := 'eddocumento';
    eddocumento.DataField := 'documento';
    eddocumento.DataSource := DataSource;
    lbparcela.SetParentComponent(Self);
    lbparcela.Name := 'lbparcela';
    lbparcela.Left := 24;
    lbparcela.Top := 327;
    lbparcela.Width := 14;
    lbparcela.Height := 13;
    lbparcela.Caption := 'parcela:';
    lbparcela.Transparent := True;
    edparcela.SetParentComponent(Self);
    edparcela.Name := 'edparcela';
    edparcela.Left := 221;
    edparcela.Top := 324;
    edparcela.Width := 200;
    edparcela.Height := 21;
    edparcela.Enabled := True;
    edparcela.TabOrder := 11;
    edparcela.Text := 'edparcela';
    edparcela.DataField := 'parcela';
    edparcela.DataSource := DataSource;
    lbemissao.SetParentComponent(Self);
    lbemissao.Name := 'lbemissao';
    lbemissao.Left := 24;
    lbemissao.Top := 354;
    lbemissao.Width := 14;
    lbemissao.Height := 13;
    lbemissao.Caption := 'emissao:';
    lbemissao.Transparent := True;
    edemissao.SetParentComponent(Self);
    edemissao.Name := 'edemissao';
    edemissao.Left := 221;
    edemissao.Top := 351;
    edemissao.Width := 200;
    edemissao.Height := 21;
    edemissao.Enabled := True;
    edemissao.TabOrder := 12;
    edemissao.Text := 'edemissao';
    edemissao.DataField := 'emissao';
    edemissao.DataSource := DataSource;
    lbvencimento.SetParentComponent(Self);
    lbvencimento.Name := 'lbvencimento';
    lbvencimento.Left := 24;
    lbvencimento.Top := 381;
    lbvencimento.Width := 14;
    lbvencimento.Height := 13;
    lbvencimento.Caption := 'vencimento:';
    lbvencimento.Transparent := True;
    edvencimento.SetParentComponent(Self);
    edvencimento.Name := 'edvencimento';
    edvencimento.Left := 221;
    edvencimento.Top := 378;
    edvencimento.Width := 200;
    edvencimento.Height := 21;
    edvencimento.Enabled := True;
    edvencimento.TabOrder := 13;
    edvencimento.Text := 'edvencimento';
    edvencimento.DataField := 'vencimento';
    edvencimento.DataSource := DataSource;
    lbpagamento.SetParentComponent(Self);
    lbpagamento.Name := 'lbpagamento';
    lbpagamento.Left := 24;
    lbpagamento.Top := 408;
    lbpagamento.Width := 14;
    lbpagamento.Height := 13;
    lbpagamento.Caption := 'pagamento:';
    lbpagamento.Transparent := True;
    edpagamento.SetParentComponent(Self);
    edpagamento.Name := 'edpagamento';
    edpagamento.Left := 221;
    edpagamento.Top := 405;
    edpagamento.Width := 200;
    edpagamento.Height := 21;
    edpagamento.Enabled := True;
    edpagamento.TabOrder := 14;
    edpagamento.Text := 'edpagamento';
    edpagamento.DataField := 'pagamento';
    edpagamento.DataSource := DataSource;
    lbvenda_id.SetParentComponent(Self);
    lbvenda_id.Name := 'lbvenda_id';
    lbvenda_id.Left := 24;
    lbvenda_id.Top := 435;
    lbvenda_id.Width := 14;
    lbvenda_id.Height := 13;
    lbvenda_id.Caption := 'venda_id:';
    lbvenda_id.Transparent := True;
    edvenda_id.SetParentComponent(Self);
    edvenda_id.Name := 'edvenda_id';
    edvenda_id.Left := 221;
    edvenda_id.Top := 432;
    edvenda_id.Width := 200;
    edvenda_id.Height := 21;
    edvenda_id.Enabled := True;
    edvenda_id.TabOrder := 15;
    edvenda_id.Text := 'edvenda_id';
    edvenda_id.DataField := 'venda_id';
    edvenda_id.DataSource := DataSource;
    lbcupons_id.SetParentComponent(Self);
    lbcupons_id.Name := 'lbcupons_id';
    lbcupons_id.Left := 24;
    lbcupons_id.Top := 462;
    lbcupons_id.Width := 14;
    lbcupons_id.Height := 13;
    lbcupons_id.Caption := 'cupons_id:';
    lbcupons_id.Transparent := True;
    edcupons_id.SetParentComponent(Self);
    edcupons_id.Name := 'edcupons_id';
    edcupons_id.Left := 221;
    edcupons_id.Top := 459;
    edcupons_id.Width := 200;
    edcupons_id.Height := 21;
    edcupons_id.Enabled := True;
    edcupons_id.TabOrder := 16;
    edcupons_id.Text := 'edcupons_id';
    edcupons_id.DataField := 'cupons_id';
    edcupons_id.DataSource := DataSource;
    lbvalor_total.SetParentComponent(Self);
    lbvalor_total.Name := 'lbvalor_total';
    lbvalor_total.Left := 24;
    lbvalor_total.Top := 489;
    lbvalor_total.Width := 14;
    lbvalor_total.Height := 13;
    lbvalor_total.Caption := 'valor_total:';
    lbvalor_total.Transparent := True;
    edvalor_total.SetParentComponent(Self);
    edvalor_total.Name := 'edvalor_total';
    edvalor_total.Left := 221;
    edvalor_total.Top := 486;
    edvalor_total.Width := 200;
    edvalor_total.Height := 21;
    edvalor_total.Enabled := True;
    edvalor_total.TabOrder := 17;
    edvalor_total.Text := 'edvalor_total';
    edvalor_total.DataField := 'valor_total';
    edvalor_total.DataSource := DataSource;
    lbvalor_saldo_pendente.SetParentComponent(Self);
    lbvalor_saldo_pendente.Name := 'lbvalor_saldo_pendente';
    lbvalor_saldo_pendente.Left := 24;
    lbvalor_saldo_pendente.Top := 516;
    lbvalor_saldo_pendente.Width := 14;
    lbvalor_saldo_pendente.Height := 13;
    lbvalor_saldo_pendente.Caption := 'valor_saldo_pendente:';
    lbvalor_saldo_pendente.Transparent := True;
    edvalor_saldo_pendente.SetParentComponent(Self);
    edvalor_saldo_pendente.Name := 'edvalor_saldo_pendente';
    edvalor_saldo_pendente.Left := 221;
    edvalor_saldo_pendente.Top := 513;
    edvalor_saldo_pendente.Width := 200;
    edvalor_saldo_pendente.Height := 21;
    edvalor_saldo_pendente.Enabled := True;
    edvalor_saldo_pendente.TabOrder := 18;
    edvalor_saldo_pendente.Text := 'edvalor_saldo_pendente';
    edvalor_saldo_pendente.DataField := 'valor_saldo_pendente';
    edvalor_saldo_pendente.DataSource := DataSource;
    lbvalor_pago.SetParentComponent(Self);
    lbvalor_pago.Name := 'lbvalor_pago';
    lbvalor_pago.Left := 24;
    lbvalor_pago.Top := 543;
    lbvalor_pago.Width := 14;
    lbvalor_pago.Height := 13;
    lbvalor_pago.Caption := 'valor_pago:';
    lbvalor_pago.Transparent := True;
    edvalor_pago.SetParentComponent(Self);
    edvalor_pago.Name := 'edvalor_pago';
    edvalor_pago.Left := 221;
    edvalor_pago.Top := 540;
    edvalor_pago.Width := 200;
    edvalor_pago.Height := 21;
    edvalor_pago.Enabled := True;
    edvalor_pago.TabOrder := 19;
    edvalor_pago.Text := 'edvalor_pago';
    edvalor_pago.DataField := 'valor_pago';
    edvalor_pago.DataSource := DataSource;
    lbmodalidade_id.SetParentComponent(Self);
    lbmodalidade_id.Name := 'lbmodalidade_id';
    lbmodalidade_id.Left := 24;
    lbmodalidade_id.Top := 570;
    lbmodalidade_id.Width := 14;
    lbmodalidade_id.Height := 13;
    lbmodalidade_id.Caption := 'modalidade_id:';
    lbmodalidade_id.Transparent := True;
    edmodalidade_id.SetParentComponent(Self);
    edmodalidade_id.Name := 'edmodalidade_id';
    edmodalidade_id.Left := 221;
    edmodalidade_id.Top := 567;
    edmodalidade_id.Width := 200;
    edmodalidade_id.Height := 21;
    edmodalidade_id.Enabled := True;
    edmodalidade_id.TabOrder := 20;
    edmodalidade_id.Text := 'edmodalidade_id';
    edmodalidade_id.DataField := 'modalidade_id';
    edmodalidade_id.DataSource := DataSource;
    lbareceber_comissao.SetParentComponent(Self);
    lbareceber_comissao.Name := 'lbareceber_comissao';
    lbareceber_comissao.Left := 24;
    lbareceber_comissao.Top := 597;
    lbareceber_comissao.Width := 14;
    lbareceber_comissao.Height := 13;
    lbareceber_comissao.Caption := 'areceber_comissao:';
    lbareceber_comissao.Transparent := True;
    edareceber_comissao.SetParentComponent(Self);
    edareceber_comissao.Name := 'edareceber_comissao';
    edareceber_comissao.Left := 221;
    edareceber_comissao.Top := 594;
    edareceber_comissao.Width := 200;
    edareceber_comissao.Height := 21;
    edareceber_comissao.Enabled := True;
    edareceber_comissao.TabOrder := 21;
    edareceber_comissao.Text := 'edareceber_comissao';
    edareceber_comissao.DataField := 'areceber_comissao';
    edareceber_comissao.DataSource := DataSource;
    lbstatus_id.SetParentComponent(Self);
    lbstatus_id.Name := 'lbstatus_id';
    lbstatus_id.Left := 24;
    lbstatus_id.Top := 624;
    lbstatus_id.Width := 14;
    lbstatus_id.Height := 13;
    lbstatus_id.Caption := 'status_id:';
    lbstatus_id.Transparent := True;
    edstatus_id.SetParentComponent(Self);
    edstatus_id.Name := 'edstatus_id';
    edstatus_id.Left := 221;
    edstatus_id.Top := 621;
    edstatus_id.Width := 200;
    edstatus_id.Height := 21;
    edstatus_id.Enabled := True;
    edstatus_id.TabOrder := 22;
    edstatus_id.Text := 'edstatus_id';
    edstatus_id.DataField := 'status_id';
    edstatus_id.DataSource := DataSource;
    lbobservacao.SetParentComponent(Self);
    lbobservacao.Name := 'lbobservacao';
    lbobservacao.Left := 24;
    lbobservacao.Top := 651;
    lbobservacao.Width := 14;
    lbobservacao.Height := 13;
    lbobservacao.Caption := 'observacao:';
    lbobservacao.Transparent := True;
    edobservacao.SetParentComponent(Self);
    edobservacao.Name := 'edobservacao';
    edobservacao.Left := 221;
    edobservacao.Top := 648;
    edobservacao.Width := 200;
    edobservacao.Height := 21;
    edobservacao.Enabled := True;
    edobservacao.TabOrder := 23;
    edobservacao.Text := 'edobservacao';
    edobservacao.DataField := 'observacao';
    edobservacao.DataSource := DataSource;
    lbfuncionario_id.SetParentComponent(Self);
    lbfuncionario_id.Name := 'lbfuncionario_id';
    lbfuncionario_id.Left := 24;
    lbfuncionario_id.Top := 678;
    lbfuncionario_id.Width := 14;
    lbfuncionario_id.Height := 13;
    lbfuncionario_id.Caption := 'funcionario_id:';
    lbfuncionario_id.Transparent := True;
    edfuncionario_id.SetParentComponent(Self);
    edfuncionario_id.Name := 'edfuncionario_id';
    edfuncionario_id.Left := 221;
    edfuncionario_id.Top := 675;
    edfuncionario_id.Width := 200;
    edfuncionario_id.Height := 21;
    edfuncionario_id.Enabled := True;
    edfuncionario_id.TabOrder := 24;
    edfuncionario_id.Text := 'edfuncionario_id';
    edfuncionario_id.DataField := 'funcionario_id';
    edfuncionario_id.DataSource := DataSource;
    lbconhecimento_transporte_id.SetParentComponent(Self);
    lbconhecimento_transporte_id.Name := 'lbconhecimento_transporte_id';
    lbconhecimento_transporte_id.Left := 24;
    lbconhecimento_transporte_id.Top := 705;
    lbconhecimento_transporte_id.Width := 14;
    lbconhecimento_transporte_id.Height := 13;
    lbconhecimento_transporte_id.Caption := 'conhecimento_transporte_id:';
    lbconhecimento_transporte_id.Transparent := True;
    edconhecimento_transporte_id.SetParentComponent(Self);
    edconhecimento_transporte_id.Name := 'edconhecimento_transporte_id';
    edconhecimento_transporte_id.Left := 221;
    edconhecimento_transporte_id.Top := 702;
    edconhecimento_transporte_id.Width := 200;
    edconhecimento_transporte_id.Height := 21;
    edconhecimento_transporte_id.Enabled := True;
    edconhecimento_transporte_id.TabOrder := 25;
    edconhecimento_transporte_id.Text := 'edconhecimento_transporte_id';
    edconhecimento_transporte_id.DataField := 'conhecimento_transporte_id';
    edconhecimento_transporte_id.DataSource := DataSource;
    lbareceber_credito.SetParentComponent(Self);
    lbareceber_credito.Name := 'lbareceber_credito';
    lbareceber_credito.Left := 24;
    lbareceber_credito.Top := 732;
    lbareceber_credito.Width := 14;
    lbareceber_credito.Height := 13;
    lbareceber_credito.Caption := 'areceber_credito:';
    lbareceber_credito.Transparent := True;
    edareceber_credito.SetParentComponent(Self);
    edareceber_credito.Name := 'edareceber_credito';
    edareceber_credito.Left := 221;
    edareceber_credito.Top := 729;
    edareceber_credito.Width := 200;
    edareceber_credito.Height := 21;
    edareceber_credito.Enabled := True;
    edareceber_credito.TabOrder := 26;
    edareceber_credito.Text := 'edareceber_credito';
    edareceber_credito.DataField := 'areceber_credito';
    edareceber_credito.DataSource := DataSource;
    lbdevolucao_id.SetParentComponent(Self);
    lbdevolucao_id.Name := 'lbdevolucao_id';
    lbdevolucao_id.Left := 24;
    lbdevolucao_id.Top := 759;
    lbdevolucao_id.Width := 14;
    lbdevolucao_id.Height := 13;
    lbdevolucao_id.Caption := 'devolucao_id:';
    lbdevolucao_id.Transparent := True;
    eddevolucao_id.SetParentComponent(Self);
    eddevolucao_id.Name := 'eddevolucao_id';
    eddevolucao_id.Left := 221;
    eddevolucao_id.Top := 756;
    eddevolucao_id.Width := 200;
    eddevolucao_id.Height := 21;
    eddevolucao_id.Enabled := True;
    eddevolucao_id.TabOrder := 27;
    eddevolucao_id.Text := 'eddevolucao_id';
    eddevolucao_id.DataField := 'devolucao_id';
    eddevolucao_id.DataSource := DataSource;
    lbrenegociacao_id.SetParentComponent(Self);
    lbrenegociacao_id.Name := 'lbrenegociacao_id';
    lbrenegociacao_id.Left := 24;
    lbrenegociacao_id.Top := 786;
    lbrenegociacao_id.Width := 14;
    lbrenegociacao_id.Height := 13;
    lbrenegociacao_id.Caption := 'renegociacao_id:';
    lbrenegociacao_id.Transparent := True;
    edrenegociacao_id.SetParentComponent(Self);
    edrenegociacao_id.Name := 'edrenegociacao_id';
    edrenegociacao_id.Left := 221;
    edrenegociacao_id.Top := 783;
    edrenegociacao_id.Width := 200;
    edrenegociacao_id.Height := 21;
    edrenegociacao_id.Enabled := True;
    edrenegociacao_id.TabOrder := 28;
    edrenegociacao_id.Text := 'edrenegociacao_id';
    edrenegociacao_id.DataField := 'renegociacao_id';
    edrenegociacao_id.DataSource := DataSource;
    lbvenda_servico_id.SetParentComponent(Self);
    lbvenda_servico_id.Name := 'lbvenda_servico_id';
    lbvenda_servico_id.Left := 24;
    lbvenda_servico_id.Top := 813;
    lbvenda_servico_id.Width := 14;
    lbvenda_servico_id.Height := 13;
    lbvenda_servico_id.Caption := 'venda_servico_id:';
    lbvenda_servico_id.Transparent := True;
    edvenda_servico_id.SetParentComponent(Self);
    edvenda_servico_id.Name := 'edvenda_servico_id';
    edvenda_servico_id.Left := 221;
    edvenda_servico_id.Top := 810;
    edvenda_servico_id.Width := 200;
    edvenda_servico_id.Height := 21;
    edvenda_servico_id.Enabled := True;
    edvenda_servico_id.TabOrder := 29;
    edvenda_servico_id.Text := 'edvenda_servico_id';
    edvenda_servico_id.DataField := 'venda_servico_id';
    edvenda_servico_id.DataSource := DataSource;
    lboperadora_cartao_id.SetParentComponent(Self);
    lboperadora_cartao_id.Name := 'lboperadora_cartao_id';
    lboperadora_cartao_id.Left := 24;
    lboperadora_cartao_id.Top := 840;
    lboperadora_cartao_id.Width := 14;
    lboperadora_cartao_id.Height := 13;
    lboperadora_cartao_id.Caption := 'operadora_cartao_id:';
    lboperadora_cartao_id.Transparent := True;
    edoperadora_cartao_id.SetParentComponent(Self);
    edoperadora_cartao_id.Name := 'edoperadora_cartao_id';
    edoperadora_cartao_id.Left := 221;
    edoperadora_cartao_id.Top := 837;
    edoperadora_cartao_id.Width := 200;
    edoperadora_cartao_id.Height := 21;
    edoperadora_cartao_id.Enabled := True;
    edoperadora_cartao_id.TabOrder := 30;
    edoperadora_cartao_id.Text := 'edoperadora_cartao_id';
    edoperadora_cartao_id.DataField := 'operadora_cartao_id';
    edoperadora_cartao_id.DataSource := DataSource;
    lbnsu_documento.SetParentComponent(Self);
    lbnsu_documento.Name := 'lbnsu_documento';
    lbnsu_documento.Left := 24;
    lbnsu_documento.Top := 867;
    lbnsu_documento.Width := 14;
    lbnsu_documento.Height := 13;
    lbnsu_documento.Caption := 'nsu_documento:';
    lbnsu_documento.Transparent := True;
    ednsu_documento.SetParentComponent(Self);
    ednsu_documento.Name := 'ednsu_documento';
    ednsu_documento.Left := 221;
    ednsu_documento.Top := 864;
    ednsu_documento.Width := 200;
    ednsu_documento.Height := 21;
    ednsu_documento.Enabled := True;
    ednsu_documento.TabOrder := 31;
    ednsu_documento.Text := 'ednsu_documento';
    ednsu_documento.DataField := 'nsu_documento';
    ednsu_documento.DataSource := DataSource;
    lbcheque_pendente.SetParentComponent(Self);
    lbcheque_pendente.Name := 'lbcheque_pendente';
    lbcheque_pendente.Left := 24;
    lbcheque_pendente.Top := 894;
    lbcheque_pendente.Width := 14;
    lbcheque_pendente.Height := 13;
    lbcheque_pendente.Caption := 'cheque_pendente:';
    lbcheque_pendente.Transparent := True;
    edcheque_pendente.SetParentComponent(Self);
    edcheque_pendente.Name := 'edcheque_pendente';
    edcheque_pendente.Left := 221;
    edcheque_pendente.Top := 891;
    edcheque_pendente.Width := 200;
    edcheque_pendente.Height := 21;
    edcheque_pendente.Enabled := True;
    edcheque_pendente.TabOrder := 32;
    edcheque_pendente.Text := 'edcheque_pendente';
    edcheque_pendente.DataField := 'cheque_pendente';
    edcheque_pendente.DataSource := DataSource;
    lbvalor_juros_pendente.SetParentComponent(Self);
    lbvalor_juros_pendente.Name := 'lbvalor_juros_pendente';
    lbvalor_juros_pendente.Left := 24;
    lbvalor_juros_pendente.Top := 921;
    lbvalor_juros_pendente.Width := 14;
    lbvalor_juros_pendente.Height := 13;
    lbvalor_juros_pendente.Caption := 'valor_juros_pendente:';
    lbvalor_juros_pendente.Transparent := True;
    edvalor_juros_pendente.SetParentComponent(Self);
    edvalor_juros_pendente.Name := 'edvalor_juros_pendente';
    edvalor_juros_pendente.Left := 221;
    edvalor_juros_pendente.Top := 918;
    edvalor_juros_pendente.Width := 200;
    edvalor_juros_pendente.Height := 21;
    edvalor_juros_pendente.Enabled := True;
    edvalor_juros_pendente.TabOrder := 33;
    edvalor_juros_pendente.Text := 'edvalor_juros_pendente';
    edvalor_juros_pendente.DataField := 'valor_juros_pendente';
    edvalor_juros_pendente.DataSource := DataSource;
    lbstatus_crediario_id.SetParentComponent(Self);
    lbstatus_crediario_id.Name := 'lbstatus_crediario_id';
    lbstatus_crediario_id.Left := 24;
    lbstatus_crediario_id.Top := 948;
    lbstatus_crediario_id.Width := 14;
    lbstatus_crediario_id.Height := 13;
    lbstatus_crediario_id.Caption := 'status_crediario_id:';
    lbstatus_crediario_id.Transparent := True;
    edstatus_crediario_id.SetParentComponent(Self);
    edstatus_crediario_id.Name := 'edstatus_crediario_id';
    edstatus_crediario_id.Left := 221;
    edstatus_crediario_id.Top := 945;
    edstatus_crediario_id.Width := 200;
    edstatus_crediario_id.Height := 21;
    edstatus_crediario_id.Enabled := True;
    edstatus_crediario_id.TabOrder := 34;
    edstatus_crediario_id.Text := 'edstatus_crediario_id';
    edstatus_crediario_id.DataField := 'status_crediario_id';
    edstatus_crediario_id.DataSource := DataSource;
    lbmensalidade_id.SetParentComponent(Self);
    lbmensalidade_id.Name := 'lbmensalidade_id';
    lbmensalidade_id.Left := 24;
    lbmensalidade_id.Top := 975;
    lbmensalidade_id.Width := 14;
    lbmensalidade_id.Height := 13;
    lbmensalidade_id.Caption := 'mensalidade_id:';
    lbmensalidade_id.Transparent := True;
    edmensalidade_id.SetParentComponent(Self);
    edmensalidade_id.Name := 'edmensalidade_id';
    edmensalidade_id.Left := 221;
    edmensalidade_id.Top := 972;
    edmensalidade_id.Width := 200;
    edmensalidade_id.Height := 21;
    edmensalidade_id.Enabled := True;
    edmensalidade_id.TabOrder := 35;
    edmensalidade_id.Text := 'edmensalidade_id';
    edmensalidade_id.DataField := 'mensalidade_id';
    edmensalidade_id.DataSource := DataSource;
    lbcredito_utilizado.SetParentComponent(Self);
    lbcredito_utilizado.Name := 'lbcredito_utilizado';
    lbcredito_utilizado.Left := 24;
    lbcredito_utilizado.Top := 1002;
    lbcredito_utilizado.Width := 14;
    lbcredito_utilizado.Height := 13;
    lbcredito_utilizado.Caption := 'credito_utilizado:';
    lbcredito_utilizado.Transparent := True;
    edcredito_utilizado.SetParentComponent(Self);
    edcredito_utilizado.Name := 'edcredito_utilizado';
    edcredito_utilizado.Left := 221;
    edcredito_utilizado.Top := 999;
    edcredito_utilizado.Width := 200;
    edcredito_utilizado.Height := 21;
    edcredito_utilizado.Enabled := True;
    edcredito_utilizado.TabOrder := 36;
    edcredito_utilizado.Text := 'edcredito_utilizado';
    edcredito_utilizado.DataField := 'credito_utilizado';
    edcredito_utilizado.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 1029;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 1026;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 37;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 1056;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 1053;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 38;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 1083;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 1080;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 39;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 1110;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 1107;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 40;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 1137;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 1134;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 41;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := AreceberDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    AreceberDataset.SetParentComponent(Self);
    AreceberDataset.Name := 'AreceberDataset';
    AreceberDataset.AfterApplyUpdates := AreceberDatasetAfterApplyUpdates;
    AreceberDataset.EntitySetName := 'Areceber';
    AreceberDataset.Connection := DMConnection.ApiConnection;
    AreceberDataset.Left := 176;
    AreceberDataset.Top := 8;
    AreceberDatasetid.SetParentComponent(AreceberDataset);
    AreceberDatasetid.Name := 'AreceberDatasetid';
    AreceberDatasetid.FieldName := 'id';
    AreceberDatasetid.Required := True;
    AreceberDatasetaliado_id.SetParentComponent(AreceberDataset);
    AreceberDatasetaliado_id.Name := 'AreceberDatasetaliado_id';
    AreceberDatasetaliado_id.FieldName := 'aliado_id';
    AreceberDatasetaliado_id.Required := True;
    AreceberDatasetdata_base_id.SetParentComponent(AreceberDataset);
    AreceberDatasetdata_base_id.Name := 'AreceberDatasetdata_base_id';
    AreceberDatasetdata_base_id.FieldName := 'data_base_id';
    AreceberDatasetdata_base_id.Required := True;
    AreceberDatasetcliente_id.SetParentComponent(AreceberDataset);
    AreceberDatasetcliente_id.Name := 'AreceberDatasetcliente_id';
    AreceberDatasetcliente_id.FieldName := 'cliente_id';
    AreceberDatasetcliente_id.Required := False;
    AreceberDatasetdocumento.SetParentComponent(AreceberDataset);
    AreceberDatasetdocumento.Name := 'AreceberDatasetdocumento';
    AreceberDatasetdocumento.FieldName := 'documento';
    AreceberDatasetdocumento.Required := False;
    AreceberDatasetdocumento.Size := 255;
    AreceberDatasetparcela.SetParentComponent(AreceberDataset);
    AreceberDatasetparcela.Name := 'AreceberDatasetparcela';
    AreceberDatasetparcela.FieldName := 'parcela';
    AreceberDatasetparcela.Required := False;
    AreceberDatasetparcela.Size := 255;
    AreceberDatasetemissao.SetParentComponent(AreceberDataset);
    AreceberDatasetemissao.Name := 'AreceberDatasetemissao';
    AreceberDatasetemissao.FieldName := 'emissao';
    AreceberDatasetemissao.Required := False;
    AreceberDatasetvencimento.SetParentComponent(AreceberDataset);
    AreceberDatasetvencimento.Name := 'AreceberDatasetvencimento';
    AreceberDatasetvencimento.FieldName := 'vencimento';
    AreceberDatasetvencimento.Required := True;
    AreceberDatasetpagamento.SetParentComponent(AreceberDataset);
    AreceberDatasetpagamento.Name := 'AreceberDatasetpagamento';
    AreceberDatasetpagamento.FieldName := 'pagamento';
    AreceberDatasetpagamento.Required := False;
    AreceberDatasetvenda_id.SetParentComponent(AreceberDataset);
    AreceberDatasetvenda_id.Name := 'AreceberDatasetvenda_id';
    AreceberDatasetvenda_id.FieldName := 'venda_id';
    AreceberDatasetvenda_id.Required := False;
    AreceberDatasetcupons_id.SetParentComponent(AreceberDataset);
    AreceberDatasetcupons_id.Name := 'AreceberDatasetcupons_id';
    AreceberDatasetcupons_id.FieldName := 'cupons_id';
    AreceberDatasetcupons_id.Required := False;
    AreceberDatasetvalor_total.SetParentComponent(AreceberDataset);
    AreceberDatasetvalor_total.Name := 'AreceberDatasetvalor_total';
    AreceberDatasetvalor_total.FieldName := 'valor_total';
    AreceberDatasetvalor_total.Required := True;
    AreceberDatasetvalor_saldo_pendente.SetParentComponent(AreceberDataset);
    AreceberDatasetvalor_saldo_pendente.Name := 'AreceberDatasetvalor_saldo_pendente';
    AreceberDatasetvalor_saldo_pendente.FieldName := 'valor_saldo_pendente';
    AreceberDatasetvalor_saldo_pendente.Required := False;
    AreceberDatasetvalor_pago.SetParentComponent(AreceberDataset);
    AreceberDatasetvalor_pago.Name := 'AreceberDatasetvalor_pago';
    AreceberDatasetvalor_pago.FieldName := 'valor_pago';
    AreceberDatasetvalor_pago.Required := False;
    AreceberDatasetmodalidade_id.SetParentComponent(AreceberDataset);
    AreceberDatasetmodalidade_id.Name := 'AreceberDatasetmodalidade_id';
    AreceberDatasetmodalidade_id.FieldName := 'modalidade_id';
    AreceberDatasetmodalidade_id.Required := True;
    AreceberDatasetareceber_comissao.SetParentComponent(AreceberDataset);
    AreceberDatasetareceber_comissao.Name := 'AreceberDatasetareceber_comissao';
    AreceberDatasetareceber_comissao.FieldName := 'areceber_comissao';
    AreceberDatasetareceber_comissao.Required := True;
    AreceberDatasetstatus_id.SetParentComponent(AreceberDataset);
    AreceberDatasetstatus_id.Name := 'AreceberDatasetstatus_id';
    AreceberDatasetstatus_id.FieldName := 'status_id';
    AreceberDatasetstatus_id.Required := False;
    AreceberDatasetobservacao.SetParentComponent(AreceberDataset);
    AreceberDatasetobservacao.Name := 'AreceberDatasetobservacao';
    AreceberDatasetobservacao.FieldName := 'observacao';
    AreceberDatasetobservacao.Required := False;
    AreceberDatasetobservacao.Size := 255;
    AreceberDatasetfuncionario_id.SetParentComponent(AreceberDataset);
    AreceberDatasetfuncionario_id.Name := 'AreceberDatasetfuncionario_id';
    AreceberDatasetfuncionario_id.FieldName := 'funcionario_id';
    AreceberDatasetfuncionario_id.Required := False;
    AreceberDatasetconhecimento_transporte_id.SetParentComponent(AreceberDataset);
    AreceberDatasetconhecimento_transporte_id.Name := 'AreceberDatasetconhecimento_transporte_id';
    AreceberDatasetconhecimento_transporte_id.FieldName := 'conhecimento_transporte_id';
    AreceberDatasetconhecimento_transporte_id.Required := False;
    AreceberDatasetareceber_credito.SetParentComponent(AreceberDataset);
    AreceberDatasetareceber_credito.Name := 'AreceberDatasetareceber_credito';
    AreceberDatasetareceber_credito.FieldName := 'areceber_credito';
    AreceberDatasetareceber_credito.Required := True;
    AreceberDatasetdevolucao_id.SetParentComponent(AreceberDataset);
    AreceberDatasetdevolucao_id.Name := 'AreceberDatasetdevolucao_id';
    AreceberDatasetdevolucao_id.FieldName := 'devolucao_id';
    AreceberDatasetdevolucao_id.Required := False;
    AreceberDatasetrenegociacao_id.SetParentComponent(AreceberDataset);
    AreceberDatasetrenegociacao_id.Name := 'AreceberDatasetrenegociacao_id';
    AreceberDatasetrenegociacao_id.FieldName := 'renegociacao_id';
    AreceberDatasetrenegociacao_id.Required := False;
    AreceberDatasetvenda_servico_id.SetParentComponent(AreceberDataset);
    AreceberDatasetvenda_servico_id.Name := 'AreceberDatasetvenda_servico_id';
    AreceberDatasetvenda_servico_id.FieldName := 'venda_servico_id';
    AreceberDatasetvenda_servico_id.Required := False;
    AreceberDatasetoperadora_cartao_id.SetParentComponent(AreceberDataset);
    AreceberDatasetoperadora_cartao_id.Name := 'AreceberDatasetoperadora_cartao_id';
    AreceberDatasetoperadora_cartao_id.FieldName := 'operadora_cartao_id';
    AreceberDatasetoperadora_cartao_id.Required := False;
    AreceberDatasetnsu_documento.SetParentComponent(AreceberDataset);
    AreceberDatasetnsu_documento.Name := 'AreceberDatasetnsu_documento';
    AreceberDatasetnsu_documento.FieldName := 'nsu_documento';
    AreceberDatasetnsu_documento.Required := False;
    AreceberDatasetnsu_documento.Size := 255;
    AreceberDatasetcheque_pendente.SetParentComponent(AreceberDataset);
    AreceberDatasetcheque_pendente.Name := 'AreceberDatasetcheque_pendente';
    AreceberDatasetcheque_pendente.FieldName := 'cheque_pendente';
    AreceberDatasetcheque_pendente.Required := True;
    AreceberDatasetvalor_juros_pendente.SetParentComponent(AreceberDataset);
    AreceberDatasetvalor_juros_pendente.Name := 'AreceberDatasetvalor_juros_pendente';
    AreceberDatasetvalor_juros_pendente.FieldName := 'valor_juros_pendente';
    AreceberDatasetvalor_juros_pendente.Required := False;
    AreceberDatasetstatus_crediario_id.SetParentComponent(AreceberDataset);
    AreceberDatasetstatus_crediario_id.Name := 'AreceberDatasetstatus_crediario_id';
    AreceberDatasetstatus_crediario_id.FieldName := 'status_crediario_id';
    AreceberDatasetstatus_crediario_id.Required := False;
    AreceberDatasetmensalidade_id.SetParentComponent(AreceberDataset);
    AreceberDatasetmensalidade_id.Name := 'AreceberDatasetmensalidade_id';
    AreceberDatasetmensalidade_id.FieldName := 'mensalidade_id';
    AreceberDatasetmensalidade_id.Required := False;
    AreceberDatasetcredito_utilizado.SetParentComponent(AreceberDataset);
    AreceberDatasetcredito_utilizado.Name := 'AreceberDatasetcredito_utilizado';
    AreceberDatasetcredito_utilizado.FieldName := 'credito_utilizado';
    AreceberDatasetcredito_utilizado.Required := True;
    AreceberDatasetcodigo_interno.SetParentComponent(AreceberDataset);
    AreceberDatasetcodigo_interno.Name := 'AreceberDatasetcodigo_interno';
    AreceberDatasetcodigo_interno.FieldName := 'codigo_interno';
    AreceberDatasetcodigo_interno.Required := True;
    AreceberDatasetexcluido.SetParentComponent(AreceberDataset);
    AreceberDatasetexcluido.Name := 'AreceberDatasetexcluido';
    AreceberDatasetexcluido.FieldName := 'excluido';
    AreceberDatasetexcluido.Required := False;
    AreceberDatasetinclusao.SetParentComponent(AreceberDataset);
    AreceberDatasetinclusao.Name := 'AreceberDatasetinclusao';
    AreceberDatasetinclusao.FieldName := 'inclusao';
    AreceberDatasetinclusao.Required := False;
    AreceberDatasetalteracao.SetParentComponent(AreceberDataset);
    AreceberDatasetalteracao.Name := 'AreceberDatasetalteracao';
    AreceberDatasetalteracao.FieldName := 'alteracao';
    AreceberDatasetalteracao.Required := False;
    AreceberDatasetexclusao.SetParentComponent(AreceberDataset);
    AreceberDatasetexclusao.Name := 'AreceberDatasetexclusao';
    AreceberDatasetexclusao.FieldName := 'exclusao';
    AreceberDatasetexclusao.Required := False;
    XDataClientAreceberGet.SetParentComponent(Self);
    XDataClientAreceberGet.Name := 'XDataClientAreceberGet';
    XDataClientAreceberGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientAreceberGet, Self, 'OnLoad', 'XDataClientAreceberGetLoad');
    XDataClientAreceberGet.Left := 64;
    XDataClientAreceberGet.Top := 8;
    XDataClientAreceberDelete.SetParentComponent(Self);
    XDataClientAreceberDelete.Name := 'XDataClientAreceberDelete';
    XDataClientAreceberDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientAreceberDelete, Self, 'OnLoad', 'XDataClientAreceberDeleteLoad');
    SetEvent(XDataClientAreceberDelete, Self, 'OnError', 'XDataClientAreceberDeleteError');
    XDataClientAreceberDelete.Left := 64;
    XDataClientAreceberDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbcliente_id.AfterLoadDFMValues;
    edcliente_id.AfterLoadDFMValues;
    lbdocumento.AfterLoadDFMValues;
    eddocumento.AfterLoadDFMValues;
    lbparcela.AfterLoadDFMValues;
    edparcela.AfterLoadDFMValues;
    lbemissao.AfterLoadDFMValues;
    edemissao.AfterLoadDFMValues;
    lbvencimento.AfterLoadDFMValues;
    edvencimento.AfterLoadDFMValues;
    lbpagamento.AfterLoadDFMValues;
    edpagamento.AfterLoadDFMValues;
    lbvenda_id.AfterLoadDFMValues;
    edvenda_id.AfterLoadDFMValues;
    lbcupons_id.AfterLoadDFMValues;
    edcupons_id.AfterLoadDFMValues;
    lbvalor_total.AfterLoadDFMValues;
    edvalor_total.AfterLoadDFMValues;
    lbvalor_saldo_pendente.AfterLoadDFMValues;
    edvalor_saldo_pendente.AfterLoadDFMValues;
    lbvalor_pago.AfterLoadDFMValues;
    edvalor_pago.AfterLoadDFMValues;
    lbmodalidade_id.AfterLoadDFMValues;
    edmodalidade_id.AfterLoadDFMValues;
    lbareceber_comissao.AfterLoadDFMValues;
    edareceber_comissao.AfterLoadDFMValues;
    lbstatus_id.AfterLoadDFMValues;
    edstatus_id.AfterLoadDFMValues;
    lbobservacao.AfterLoadDFMValues;
    edobservacao.AfterLoadDFMValues;
    lbfuncionario_id.AfterLoadDFMValues;
    edfuncionario_id.AfterLoadDFMValues;
    lbconhecimento_transporte_id.AfterLoadDFMValues;
    edconhecimento_transporte_id.AfterLoadDFMValues;
    lbareceber_credito.AfterLoadDFMValues;
    edareceber_credito.AfterLoadDFMValues;
    lbdevolucao_id.AfterLoadDFMValues;
    eddevolucao_id.AfterLoadDFMValues;
    lbrenegociacao_id.AfterLoadDFMValues;
    edrenegociacao_id.AfterLoadDFMValues;
    lbvenda_servico_id.AfterLoadDFMValues;
    edvenda_servico_id.AfterLoadDFMValues;
    lboperadora_cartao_id.AfterLoadDFMValues;
    edoperadora_cartao_id.AfterLoadDFMValues;
    lbnsu_documento.AfterLoadDFMValues;
    ednsu_documento.AfterLoadDFMValues;
    lbcheque_pendente.AfterLoadDFMValues;
    edcheque_pendente.AfterLoadDFMValues;
    lbvalor_juros_pendente.AfterLoadDFMValues;
    edvalor_juros_pendente.AfterLoadDFMValues;
    lbstatus_crediario_id.AfterLoadDFMValues;
    edstatus_crediario_id.AfterLoadDFMValues;
    lbmensalidade_id.AfterLoadDFMValues;
    edmensalidade_id.AfterLoadDFMValues;
    lbcredito_utilizado.AfterLoadDFMValues;
    edcredito_utilizado.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    AreceberDataset.AfterLoadDFMValues;
    AreceberDatasetid.AfterLoadDFMValues;
    AreceberDatasetaliado_id.AfterLoadDFMValues;
    AreceberDatasetdata_base_id.AfterLoadDFMValues;
    AreceberDatasetcliente_id.AfterLoadDFMValues;
    AreceberDatasetdocumento.AfterLoadDFMValues;
    AreceberDatasetparcela.AfterLoadDFMValues;
    AreceberDatasetemissao.AfterLoadDFMValues;
    AreceberDatasetvencimento.AfterLoadDFMValues;
    AreceberDatasetpagamento.AfterLoadDFMValues;
    AreceberDatasetvenda_id.AfterLoadDFMValues;
    AreceberDatasetcupons_id.AfterLoadDFMValues;
    AreceberDatasetvalor_total.AfterLoadDFMValues;
    AreceberDatasetvalor_saldo_pendente.AfterLoadDFMValues;
    AreceberDatasetvalor_pago.AfterLoadDFMValues;
    AreceberDatasetmodalidade_id.AfterLoadDFMValues;
    AreceberDatasetareceber_comissao.AfterLoadDFMValues;
    AreceberDatasetstatus_id.AfterLoadDFMValues;
    AreceberDatasetobservacao.AfterLoadDFMValues;
    AreceberDatasetfuncionario_id.AfterLoadDFMValues;
    AreceberDatasetconhecimento_transporte_id.AfterLoadDFMValues;
    AreceberDatasetareceber_credito.AfterLoadDFMValues;
    AreceberDatasetdevolucao_id.AfterLoadDFMValues;
    AreceberDatasetrenegociacao_id.AfterLoadDFMValues;
    AreceberDatasetvenda_servico_id.AfterLoadDFMValues;
    AreceberDatasetoperadora_cartao_id.AfterLoadDFMValues;
    AreceberDatasetnsu_documento.AfterLoadDFMValues;
    AreceberDatasetcheque_pendente.AfterLoadDFMValues;
    AreceberDatasetvalor_juros_pendente.AfterLoadDFMValues;
    AreceberDatasetstatus_crediario_id.AfterLoadDFMValues;
    AreceberDatasetmensalidade_id.AfterLoadDFMValues;
    AreceberDatasetcredito_utilizado.AfterLoadDFMValues;
    AreceberDatasetcodigo_interno.AfterLoadDFMValues;
    AreceberDatasetexcluido.AfterLoadDFMValues;
    AreceberDatasetinclusao.AfterLoadDFMValues;
    AreceberDatasetalteracao.AfterLoadDFMValues;
    AreceberDatasetexclusao.AfterLoadDFMValues;
    XDataClientAreceberGet.AfterLoadDFMValues;
    XDataClientAreceberDelete.AfterLoadDFMValues;
  end;
end;

end.
